export default __webpack_public_path__ + "static/media/video-call-connect.e7b1bfd8.mp3";